import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';

export type AuthState = {
  readonly isLoading: boolean;
  readonly isAuthenticated: boolean;
  readonly error: string;
  readonly sessionToken: string;
  readonly next: string;
  readonly finishRegister: boolean;
};

const initialState: AuthState = {
  isLoading: false,
  isAuthenticated: false,
  error: '',
  sessionToken: '',
  next: '',
  finishRegister: false,
};

function reducer(state: AuthState = initialState, action: ActionTypes) {
  switch (action.type) {
    case ActionKeys.REGISTER:
    case ActionKeys.LOGIN:
    case ActionKeys.RESET_PASSWORD:
      return {
        ...state,
        isLoading: true,
        isAuthenticated: false,
      };
    case ActionKeys.REGISTER_SUCCESS:
      return {
        ...state,
        sessionToken: action.payload.sessionToken,
        next: action.payload.next,
        isLoading: false,
        isAuthenticated: true,
      };
    case ActionKeys.LOGIN_SUCCESS:
    case ActionKeys.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
      };
    case ActionKeys.REGISTER_ERROR:
    case ActionKeys.LOGIN_ERROR:
    case ActionKeys.RESET_PASSWORD_ERROR:
      return {
        ...state,
        error: action.payload.error.errorMessage,
        isLoading: false,
        isAuthenticated: false,
      };
    case ActionKeys.RESET_AUTH_ERROR:
      return {
        ...state,
        error: '',
        isLoading: false,
      };
    case ActionKeys.FINISH_REGISTER:
      return {
        ...state,
        finishRegister: true,
      };
    case ActionKeys.RESEND_VERIFICATION_ERROR:
      return {
        ...state,
        error: action.payload.error.errorMessage,
      };
    default:
      return state;
  }
}

export default reducer;
